export default "__VITE_ASSET__3ca44ec9__"